import type { EventTrackingDecorator } from '@change-corgi/core/eventTracker';

class ScrollDepthDecorator implements EventTrackingDecorator {
	// oxlint-disable-next-line class-methods-use-this
	async getEventTrackingData(): Promise<Readonly<Record<string, unknown>>> {
		return Promise.resolve({
			scroll_depth: getScrollDepthPercentage(),
		});
	}
}

function getScrollDepthPercentage(): number | null {
	if (typeof window === 'undefined' || typeof document === 'undefined') return null; // SSR safety

	const scrollableHeight = document.body.scrollHeight - window.innerHeight;
	if (scrollableHeight <= 0) return 100;

	// Using Math.max to ensure scrollY is not negative, which can happen in some edge cases
	const scrollY = Math.max(window.scrollY, 0);

	// Limiting scrollY to the scrollable height to avoid returning values greater than 100% in cases where scrollY exceeds the scrollable height.
	const clampedScrollY = Math.floor(Math.min(scrollY, scrollableHeight));

	return Math.round((clampedScrollY / scrollableHeight) * 100);
}

export function createScrollDepthDecorator(): ScrollDepthDecorator {
	return new ScrollDepthDecorator();
}
